import React from 'react';
import { Box, IconButton, TextField, Button, Typography } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';

const StepperQuestion = ({
  question,
  value = 1,
  onChange,
  error,
  answers,
  interpolateText
}) => {
  // Parse min/max/default from question options or use defaults
  let min = 1;
  let max = 15;
  let defaultValue = 1;
  
  if (question.options && Array.isArray(question.options)) {
    question.options.forEach(option => {
      if (typeof option === 'string') {
        if (option.startsWith('min=')) {
          min = parseInt(option.replace('min=', ''), 10);
        } else if (option.startsWith('max=')) {
          max = parseInt(option.replace('max=', ''), 10);
        } else if (option.startsWith('default=')) {
          defaultValue = parseInt(option.replace('default=', ''), 10);
        }
      }
    });
  }
  
  // Use the parsed default if no value is provided
  const currentValue = value !== undefined && value !== null ? value : defaultValue;
  const officeOption = question.options && question.options.includes('Office');

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 600, whiteSpace: 'pre-line' }}>
        {interpolateText(question.text, answers)}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'center', mb: 2 }}>
        <IconButton
          onClick={() => onChange(Math.max(min, (parseInt(currentValue) || min) - 1))}
          disabled={parseInt(currentValue) <= min}
        >
          <Remove />
        </IconButton>
        <TextField
          type="number"
          value={currentValue}
          onChange={e => {
            const val = e.target.value;
            if (/^\d*$/.test(val) && val >= min && val <= max) {
              onChange(val);
            }
          }}
          error={!!error}
          helperText={error}
          inputProps={{ min, max, style: { textAlign: 'center', fontSize: '1.2rem', fontWeight: 600 } }}
          sx={{ width: 100 }}
        />
        <IconButton
          onClick={() => onChange(Math.min(max, (parseInt(currentValue) || 0) + 1))}
          disabled={parseInt(currentValue) >= max}
        >
          <Add />
        </IconButton>
        {officeOption && (
          <Button
            variant={currentValue === 'Office' ? 'contained' : 'outlined'}
            onClick={() => onChange('Office')}
            sx={{ ml: 2 }}
          >
            Office
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default StepperQuestion; 